// extracted by mini-css-extract-plugin
export default {"root":"_203ya","icon":"_d71L","unreadCircle":"hQ24y"};